export default {"src":"/_next/static/media/calendar.2e014411.svg","height":23,"width":23};